import { Slider, styled } from '@mui/material';

const CustomSlider = styled(Slider)`
  height: 2px;
  padding: 66px 0 90px;
  margin: 0 0 20px;

  &:hover {
    z-index: 9999999999;
  }

  & .MuiSlider-thumb {
    height: 26px;
    width: 26px;
    background-color: ${({ customcolor }) => customcolor};
    &:hover {
      box-shadow: 0 0 0 8px rgba(58, 133, 137, 0.16);
      z-index: 9999999999;
    }
    & .label {
      color: white;
      font-size: 0.875rem;
    }
    & .tooltip {
      position: absolute;
      transform-origin: top left;
      transform: rotate(-90deg);
      font-size: 0.875rem;
      white-space: nowrap;
      left: 3px;
      top: -4px;
      &.bottom {
        transform: rotate(-90deg) translateX(-100%);
        top: 31px;
      }
      & .order {
        font-size: 0.875rem;
        color: black;
      }
    }
  }

  & .MuiSlider-track {
    height: 2px;
  }

  & .MuiSlider-rail {
    color: #d8d8d8;
    height: 2px;
  }
`;

export default CustomSlider;
